// assets/gs-search-overlay.js

(function () {
  const OVERLAY_ID = "gsSearchOverlay";
  const INPUT_ID = "gsSearchOverlayInput";
  const RESULTS_ID = "gsSearchOverlayResults";
  const HISTORY_ID = "gsSearchOverlayHistory";

  const HISTORY_KEY = "gs_search_history_v1";
  const HISTORY_MAX = 8;

  const money = (cents, currency = "") => {
    if (typeof cents !== "number") return "";
    const value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0 });
    return currency ? `${currency} ${value}` : value;
  };

  const escapeHtml = (str) =>
    String(str).replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[m]));

  const getHistory = () => {
    try {
      return JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]");
    } catch {
      return [];
    }
  };

  const setHistory = (arr) => {
    try {
      localStorage.setItem(HISTORY_KEY, JSON.stringify(arr.slice(0, HISTORY_MAX)));
    } catch {}
  };

  const addToHistory = (q) => {
    const query = q.trim();
    if (!query) return;
    const prev = getHistory();
    const next = [query, ...prev.filter((x) => x.toLowerCase() !== query.toLowerCase())];
    setHistory(next);
  };

  const renderHistory = () => {
    const el = document.getElementById(HISTORY_ID);
    if (!el) return;
    const items = getHistory();
    if (!items.length) {
      el.innerHTML = "";
      return;
    }
    el.innerHTML = `
      <div class="gs-so__history-title">HISTORIAL DE BÚSQUEDA</div>
      <div class="gs-so__history-chips">
        ${items
          .map(
            (q) => `<button class="gs-so__chip" type="button" data-q="${escapeHtml(q)}">${escapeHtml(q)} <span aria-hidden="true">×</span></button>`
          )
          .join("")}
      </div>
    `;

    el.querySelectorAll(".gs-so__chip").forEach((btn) => {
      btn.addEventListener("click", () => {
        const q = btn.getAttribute("data-q") || "";
        const input = document.getElementById(INPUT_ID);
        if (input) {
          input.value = q;
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.focus();
        }
      });
    });
  };

  const openOverlay = () => {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    overlay.setAttribute("aria-hidden", "false");
    overlay.classList.add("is-open");
    document.documentElement.classList.add("gs-so--lock");
    document.body.classList.add("gs-so--lock");

    renderHistory();

    const input = document.getElementById(INPUT_ID);
    if (input) {
      // si el usuario venía escribiendo en el header, copia el texto
      const headerInput = document.querySelector(".gs-header-search input");
      if (headerInput && headerInput.value && !input.value) input.value = headerInput.value;

      input.focus();
      input.setSelectionRange(input.value.length, input.value.length);
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
  };

  const closeOverlay = () => {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    overlay.setAttribute("aria-hidden", "true");
    overlay.classList.remove("is-open");
    document.documentElement.classList.remove("gs-so--lock");
    document.body.classList.remove("gs-so--lock");

    // opcional: limpia resultados
    const results = document.getElementById(RESULTS_ID);
    if (results) results.innerHTML = "";
  };

  const debounce = (fn, wait = 150) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const fetchSuggestions = async (query) => {
    const q = query.trim();
    if (!q) return { products: [] };

    const url =
      `/search/suggest.json?q=${encodeURIComponent(q)}` +
      `&resources[type]=product` +
      `&resources[limit]=10` +
      `&resources[options][unavailable_products]=last` +
      `&resources[options][fields]=title,product_type,variants.title,variants.sku,tag`;

    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Suggest failed");
    return res.json();
  };

  const renderProducts = (data) => {
  const results = document.getElementById(RESULTS_ID);
  if (!results) return;

  const currency =
    window.Shopify && Shopify.currency && Shopify.currency.active
      ? Shopify.currency.active
      : "";

  const products = data?.resources?.results?.products || [];

  if (!products.length) {
    results.innerHTML = `
      <div class="gs-so__empty">
        No encontramos resultados. Prueba otro nombre 👀
      </div>
    `;
    return;
  }

  results.innerHTML = `
    <div class="gs-so__results-wrapper">

      <button class="gs-scroll-btn gs-scroll-left" aria-label="Scroll left">
        ‹
      </button>

      <div class="gs-so__grid">
        ${products
          .map((p) => {
            const title = escapeHtml(p.title || "");
            const url = p.url || "#";
            const img = p.image ? p.image : "";
            const price =
              typeof p.price === "number"
                ? money(p.price, currency)
                : "";

            return `
              <a class="gs-so__card" href="${url}">
                <div class="gs-so__thumb">
                  ${
                    img
                      ? `<img src="${img}" alt="${title}" loading="lazy">`
                      : `<div class="gs-so__thumb--ph"></div>`
                  }
                </div>
                <div class="gs-so__meta">
                  <div class="gs-so__title">${title}</div>
                  ${
                    price
                      ? `<div class="gs-so__price">${price}</div>`
                      : ``
                  }
                </div>
              </a>
            `;
          })
          .join("")}
      </div>

      <button class="gs-scroll-btn gs-scroll-right" aria-label="Scroll right">
        ›
      </button>

    </div>
  `;

  // Activar scroll
  const grid = results.querySelector(".gs-so__grid");
  const leftBtn = results.querySelector(".gs-scroll-left");
  const rightBtn = results.querySelector(".gs-scroll-right");

  if (!grid || !leftBtn || !rightBtn) return;

  const scrollAmount = 400;

  const updateButtons = () => {
    leftBtn.style.opacity = grid.scrollLeft > 10 ? "1" : "0";
    rightBtn.style.opacity =
      grid.scrollLeft + grid.clientWidth < grid.scrollWidth - 10
        ? "1"
        : "0";
  };

  leftBtn.addEventListener("click", () => {
    grid.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  });

  rightBtn.addEventListener("click", () => {
    grid.scrollBy({ left: scrollAmount, behavior: "smooth" });
  });

  grid.addEventListener("scroll", updateButtons);

  // Inicializar estado
  setTimeout(updateButtons, 100);
};

  const bindOverlay = () => {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    // cerrar por backdrop click
    overlay.addEventListener("click", (e) => {
      if (e.target && e.target.classList.contains("gs-so__backdrop")) closeOverlay();
    });

    // cerrar por botón X
    overlay.querySelectorAll("[data-gs-close]").forEach((btn) => {
      btn.addEventListener("click", closeOverlay);
    });

    // cerrar por ESC
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && overlay.classList.contains("is-open")) closeOverlay();
    });

    const input = document.getElementById(INPUT_ID);
    const results = document.getElementById(RESULTS_ID);
    if (!input || !results) return;

    const doSearch = debounce(async () => {
      const q = input.value.trim();

      if (!q) {
        results.innerHTML = "";
        renderHistory();
        return;
      }

      try {
        const data = await fetchSuggestions(q);
        renderProducts(data);
      } catch {
        results.innerHTML = `<div class="gs-so__empty">Ups… hubo un error cargando resultados.</div>`;
      }
    }, 160);

    input.addEventListener("input", doSearch);

    // Enter => ir a /search?q=
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        const q = input.value.trim();
        if (!q) return;
        addToHistory(q);
        window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
      }
    });

    // botón buscar
    const btn = overlay.querySelector("[data-gs-submit]");
    if (btn) {
      btn.addEventListener("click", () => {
        const q = input.value.trim();
        if (!q) return;
        addToHistory(q);
        window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
      });
    }
  };

  const bindHeaderTriggers = () => {
    // abre al hacer focus/click en el input del header (tu buscador custom)
    document.addEventListener("focusin", (e) => {
      const input = e.target;
      if (input && input.matches(".gs-header-search input")) openOverlay();
    });

    document.addEventListener("click", (e) => {
      const el = e.target;
      if (!el) return;

      // click en cualquier parte del buscador
      if (el.closest && el.closest(".gs-header-search")) {
        openOverlay();
      }
    });
  };

  const init = () => {
    bindOverlay();
    bindHeaderTriggers();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();